import { module } from 'angular';

import { State } from './';
import { ChatIadvize, default as chatIadvizeName } from './chat-iadvize.component.ajs';

export default module('contact.agent.contact-view.chat-iadvize', [State]).component(chatIadvizeName, new ChatIadvize()).name;
